<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g
      clip-path="url(#6cf1g0n5aa)"
      stroke="#fff"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="m8.667 12.667 6-4.667-6-4.667v9.334zM1.334 12.667l6-4.667-6-4.667v9.334z" />
    </g>
    <defs>
      <clipPath id="6cf1g0n5aa">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
</template>
